import { Injectable } from '@angular/core';
import gql from "graphql-tag";
import {stockFragments} from "../../store-management/services/stock.service";

export const fetchEStoreArticles = gql`
  query FetchEStoreArticles($locID:String!, $onlyUnprocessed:Boolean = true) {
    eStoreArticles(locationId:$locID, onlyUnprocessed:$onlyUnprocessed) {
      id, standort_id, ean, beschreibung
      migration_entry @skip(if: $onlyUnprocessed) {
        id, e_store_id, e_store_standort_id 
        do_not_migrate
        administration_unit {cuid label}
        stock_item {cuid label administration_unit {cuid label}}
        depot {cuid label} 
        depot_yard {cuid label}
      }
    }
  }
`;

export const createMigrationEntry = gql`
  mutation CreateMigrationEntry($input:EStoreMigrationEntryInput!) {
    createMigrationEntry(input:$input) {
      id, e_store_id, e_store_standort_id
      do_not_migrate
      administration_unit {cuid label}
      stock_item {cuid label administration_unit {cuid label}}
      depot {cuid label}
      depot_yard {cuid label}
    }
  }
`;

export const deleteMigrationEntry = gql`
  mutation DeleteMigrationEntry($id: Int!) {
    deleteMigrationEntry(id: $id)
  }
`;

export const runEStoreMigration = gql`
  mutation RunEStoreMigration($eStoreLocationId:Int!, $visbosAdminUnitCuid:String!) {
    runEStoreMigration(eStoreLocationId:$eStoreLocationId, visbosAdminUnitCuid:$visbosAdminUnitCuid) {
      ...StockDetailFields
    }
  }
  ${stockFragments.stock}
`;

export const autoAssignArticles = gql`
  mutation AutoAssignArticles($eStoreLocationId:Int!, $vbDepotCuid:String!) {
    autoAssignArticles(eStoreLocationId: $eStoreLocationId, vbDepotCuid: $vbDepotCuid) {
      id, e_store_id, e_store_standort_id
      stock_item {
        cuid label
        products {
          cuid label
          packings {
            cuid label article_number
          }
        }
      }
    }
  }
`;

@Injectable()
export class EStoreMigrationService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/admin/services/e-store-migration.service.ts